import * as React from "react";

function SvgClearViolation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 1.833L32.167 0l-3.724 3.724H6.173a2.449 2.449 0 00-2.448 2.449v22.269L0 32.167 1.833 34 34 1.833zM14.41 17.757l1.335-1.335v-6.283a2.448 2.448 0 012.449-2.449h.445a2.448 2.448 0 012.448 2.449v.94l1.323-1.322a3.673 3.673 0 00-3.66-3.362h-.668a3.673 3.673 0 00-3.673 3.673v7.69zm6.677.084l-1.335 1.336v.802a4.008 4.008 0 01-1.336 7.785 4.008 4.008 0 01-3.946-3.306l-1.089 1.09a5.345 5.345 0 0010.377-1.79 5.34 5.34 0 00-2.67-4.628v-1.289zm-2.67 12.595a6.679 6.679 0 01-6.06-3.866l-6.513 6.515c.108.014.218.022.33.022h24.485a2.448 2.448 0 002.448-2.449V6.173c0-.112-.007-.222-.022-.33l-3.224 3.225a.612.612 0 01.575.61v.112a.612.612 0 01-.612.612h-1.298l-2.67 2.671h2.632c.339 0 .613.274.613.612v.112a.612.612 0 01-.613.612h-2.782a.612.612 0 01-.611-.576l-2.672 2.673v1.909a6.678 6.678 0 01-4.007 12.02zm7.29-13.356a.612.612 0 00-.613.612v.111c0 .338.274.612.612.612h4.118a.612.612 0 00.612-.612v-.111a.612.612 0 00-.612-.612h-4.118z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgClearViolation;
